/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type TriggerSkillSuggestionRequestBody = {
  /**
   * The skill ID.
   */
  id: string;
};

/** @internal */
export type TriggerSkillSuggestionRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const TriggerSkillSuggestionRequestBody$outboundSchema: z.ZodMiniType<
  TriggerSkillSuggestionRequestBody$Outbound,
  TriggerSkillSuggestionRequestBody
> = z.object({
  id: z.string(),
});

export function triggerSkillSuggestionRequestBodyToJSON(
  triggerSkillSuggestionRequestBody: TriggerSkillSuggestionRequestBody,
): string {
  return JSON.stringify(
    TriggerSkillSuggestionRequestBody$outboundSchema.parse(
      triggerSkillSuggestionRequestBody,
    ),
  );
}
